module.exports = __webpack_public_path__ + "assets/c59bc72a689a9b14f257a168b4e1f960.mp3";